import {
  SAVE_EAD_STARTED, SAVE_EAD_SUCCESS, SAVE_EAD_FAILED,
  GET_EADPETITION_STARTED, GET_EADPETITION_SUCCESS, GET_EADPETITION_FAILED,
  UPDATE_EADPETITION_STARTED, UPDATE_EADPETITION_SUCCESS, UPDATE_EADPETITION_FAILED,
  CREATE_EADPETITION_STARTED, CREATE_EADPETITION_SUCCESS, CREATE_EADPETITION_FAILED,
  SAVE_EADFORMSUBMIT_STARTED, SAVE_EADFORMSUBMIT_SUCCESS, SAVE_EADFORMSUBMIT_FAILED

} from '../actions/VisaCareEADCase';

const intialData = {
  status: {
    statusCode: 300,
    statusDisplay: "",
    statusValue: true
  },
  items: [],
  userInput: {
    insert_datetime: "",
    inserted_by: "",
    update_datetime: "",
    updated_by: ""

  },
  isLoading: true,
  isFormSubmit: false,
  isLoggedIn: false,
  error: ''
};
export const EADCaseData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVE_EAD_STARTED:
      return {
        ...state,
        items: [],
        isLoading: true,
      };
    case SAVE_EAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_EAD_FAILED:
      return {
        ...state,
        isLoading: true,
      };
    default:
      return state;
  }
}

export const EADPetitionData = (state = intialData, action: any) => {
  switch (action.type) {
    case GET_EADPETITION_STARTED:
      return {
        ...state,
        items: [],
        isLoading: true,
      };
    case GET_EADPETITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_EADPETITION_FAILED:
      return {
        ...state,
        isLoading: true,
        status: "Fail"
      };
    case UPDATE_EADPETITION_STARTED:
      return {
        ...state,
        items: [],
        isLoading: true,
      };
    case UPDATE_EADPETITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_EADPETITION_FAILED:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_EADPETITION_STARTED:
      return {
        ...state,
        items: [],
        isLoading: true,
      };
    case CREATE_EADPETITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case CREATE_EADPETITION_FAILED:
      return {
        ...state,
        isLoading: true,
      };


    default:
      return state;

  }
}
export const EADPetitionPdfData = (state = intialData, action: any) => {
 
  switch (action.type) {

    case SAVE_EADFORMSUBMIT_STARTED:
      return {
        ...state,
        items: [],
        isLoading: true,
      };
    case SAVE_EADFORMSUBMIT_SUCCESS:
       
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_EADFORMSUBMIT_FAILED:
      return {
        ...state,
        isLoading: true,
      };
    default:
      return state;

  }
}